import {
    NotificationsUpdateSmsDto,
    NotificationsUpdateEmailDto,
    NotificationsUpdatePhoneNumberDto
} from '../dtos/NotificationUpdateDto';

const generatePostData = {
    phoneNumber: (phoneNumber: string) => {
        const data: NotificationsUpdatePhoneNumberDto = {
            phoneNumber
        };

        return data;
    },
    shouldReceiveEmail: (shouldReceiveEmail: boolean) => {
        const data: NotificationsUpdateEmailDto = {
            shouldReceiveEmail
        };

        return data;
    },
    shouldReceiveSms: (shouldReceiveSms: boolean) => {
        const data: NotificationsUpdateSmsDto = {
            shouldReceiveSms
        };

        return data;
    }
};

export { generatePostData };
